import { render } from "./edit-credit-notes.vue?vue&type=template&id=fadcd5c0"
import script from "./edit-credit-notes.vue?vue&type=script&lang=js"
export * from "./edit-credit-notes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__